module.exports = __webpack_public_path__ + "77368f8f4d4173723ea88363f823887b.jpeg";